import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import C from "../../../constants";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
//import parseAddress from 'parse-address';
import { findAnswer } from '../../../state/questionStates';

class PseudoQuoteHandler extends Component {
    componentDidMount() {
        //setTimeout(() => this.handleResult(this.props.store), 1500);
        this.handleResult(this.props.store);
    }

    removeSymbols(obj) {
        if (obj && obj.value && typeof obj.value === 'string') {
            obj.value = obj.value.replace(/\$|,|\s/g, "");
        }

        return obj;
    };

    ensure(val, prepend) {
        let result = val ? val : "";
        if (prepend) {
            return prepend + result;
        }
        return String(result);
    }

    constructResult(state) {
        let firstName = findAnswer(state, "name", "firstName");
        let lastName = findAnswer(state, "name", "lastName");
        let dob = findAnswer(state, "dob", "dateOfBirth");
        let homeRent = findAnswer(state, "home-rent", "homeOrRental");
        let review = homeRent.value === "Auto" ? "review-car" : "review-home";
        let premiumTotal = this.removeSymbols(findAnswer(state, review, "premium"));
        let effectiveDate = findAnswer(state, review, "effective_date");
        let coverageA, coverageB, coverageC, coverageD, coverageE, coverageF;
        if (homeRent.value !== "Auto"){
            console.log("Here");
            //homeRent.value = homeRent.value === "Homeowners" ? "home" : "rent";
            coverageA = this.removeSymbols(findAnswer(state, review, "coverage_a"));
            coverageB = this.removeSymbols(findAnswer(state, review, "coverage_b"));
            coverageC = this.removeSymbols(findAnswer(state, review, "coverage_c"));
            coverageD = this.removeSymbols(findAnswer(state, review, "coverage_d"));
            coverageE = this.removeSymbols(findAnswer(state, review, "coverage_e"));
            coverageF = this.removeSymbols(findAnswer(state, review, "coverage_f"));
        }
        let deductible = this.removeSymbols(findAnswer(state, review, "deductible"));
        let address = findAnswer(state, review, "address");
        //let parsedAddress = parseAddress.parseLocation(address.value);
        let emailAddress = findAnswer(state, "email", "email");

        console.log(JSON.stringify(firstName));
        console.log(JSON.stringify(lastName));
        console.log(JSON.stringify(dob));
        console.log(JSON.stringify(premiumTotal));
        console.log(JSON.stringify(homeRent));
        console.log(JSON.stringify(deductible));
        if (homeRent.value !== "Auto"){
            console.log(JSON.stringify(coverageA));
            console.log(JSON.stringify(coverageB));
            console.log(JSON.stringify(coverageC));
            console.log(JSON.stringify(coverageD));
            console.log(JSON.stringify(coverageE));
            console.log(JSON.stringify(coverageF));
        }
        console.log(JSON.stringify(address));
        console.log(JSON.stringify(effectiveDate));

        if (homeRent.value === "Auto"){
            return {
                first_name: this.ensure(firstName.value),
                last_name: this.ensure(lastName.value),
                deductible: this.ensure(deductible.value),
                effective_date: this.ensure(effectiveDate ? effectiveDate.value : ""),
                premium: this.ensure((parseFloat(premiumTotal.value) * 0.9).toFixed(2)),
                //address_1: this.ensure(parsedAddress ? parsedAddress.number : "") + this.ensure(parsedAddress ? parsedAddress.street : "", " ") + this.ensure(parsedAddress ? parsedAddress.type : "", " "),
                //address_2: "",
                //city: this.ensure(parsedAddress ? parsedAddress.city : ""),
                //state: this.ensure(parsedAddress ? parsedAddress.state : ""),
                //zip: this.ensure(parsedAddress ? parsedAddress.zip : ""),
                home_rent: "auto",
                company: "Mass Insure",
                email: emailAddress.value
            }
        }

        return {
            first_name: this.ensure(firstName.value),
            last_name: this.ensure(lastName.value),
            coverage_a: this.ensure(coverageA.value),
            coverage_b: this.ensure(coverageB.value),
            coverage_c: this.ensure(coverageC.value),
            coverage_d: this.ensure(coverageD.value),
            coverage_e: this.ensure(coverageE.value),
            coverage_f: this.ensure(coverageF.value),
            deductible: this.ensure(deductible.value),
            effective_date: this.ensure(effectiveDate ? effectiveDate.value : ""),
            premium: this.ensure((parseFloat(premiumTotal.value) * 0.9).toFixed(2)),
            //address_1: this.ensure(parsedAddress ? parsedAddress.number : "") + this.ensure(parsedAddress ? parsedAddress.street : "", " ") + this.ensure(parsedAddress ? parsedAddress.type : "", " "),
            //address_2: "",
            //city: this.ensure(parsedAddress ? parsedAddress.city : ""),
            //state: this.ensure(parsedAddress ? parsedAddress.state : ""),
            //zip: this.ensure(parsedAddress ? parsedAddress.zip : ""),
            home_rent: "home",
            company: "Mass Insure",
            email: emailAddress.value
        };
    }

    handleResult(store) {
        let state = store.getState();

        let result = this.constructResult(state);
        store.dispatch({ type: C.STORE_RESULT_DATA, result: result });
        store.dispatch({ type: C.NEXT_QUESTION });
    }

    render() {
        let question = this.props.question;

        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={this.props.store}/>
                <HelperContent question={question} />
            </div>
        )
    }
};

PseudoQuoteHandler.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default PseudoQuoteHandler;
